import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TramActividadService } from '../../../../services/database/tramActividad.service';
import { IGetTramiteActividades } from '../../../../shared/interfaces/database/tramite';
import { SeguimientosHistorialComponent } from './seguimientos-historial/seguimientos-historial.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LocalService, AccessRole, ICustomTable, CustomTableComponent, DataColumnType, ButtonColumnType } from 'lib-base';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-tramite-historial',
  standalone: true,
  imports: [
    CommonModule, CustomTableComponent,
    SeguimientosHistorialComponent
  ],
  template:`
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>

<ng-template #tableRowexpansion let-data>
    <app-seguimientos-historial [actividadId]="data.id"
                                class="app-card w-11 mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
  `
})
export class TramiteHistorialComponent implements OnInit {
  @Input() tramRegistroId !: number;

  customTable !: ICustomTable;
  trans: any = {};
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _tas: TramActividadService, public readonly ls: LocalService, private readonly _router: Router, private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate().then(() => this.configTable());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      usuarioAsignado: this._t.get('common.usuarioAsignado'),
      estado: this._t.get('common.estado'),
      abrir: this._t.get('common.abrir'),
      fechaInicioPlanificada: this._t.get('msg.fechaInicioPlanificada'),
      fechaCierrePlanificada: this._t.get('msg.fechaCierrePlanificada'),
      fechaInicioReal: this._t.get('msg.fechaInicioReal'),
      fechaFinalizacionReal: this._t.get('msg.fechaFinalizacionReal'),
      actividades: this._t.get('common.actividades'),
      fir: this._t.get('common.fir'),
      ffr: this._t.get('common.ffr'),
      fip: this._t.get('common.fip'),
      fcp: this._t.get('common.fcp'),
    }));
  }

  private configTable(){
    this.customTable = {
      columns: [
        {
          field: 'expand',
          header: '',
          class:'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'codificacion',
          header: this.trans.actividad,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          header: this.trans.orden,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'usuarioAsignadoCorreo',
          header: this.trans.usuarioAsignado,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'estadoDescripcion',
          header: this.trans.estado,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.ESTADO_TAG
        },
        {
          field: 'fechaRealInicio',
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          header: this.trans.fir,
          sort: true,
          dataType: DataColumnType.DATE,
          headerTooltip:{
            message: this.trans.fechaInicioReal,
            disabled: false
          }
        },
        {
          field: 'fechaRealCierre',
          header: this.trans.ffr,
          dataType: DataColumnType.DATE,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          headerTooltip:{
            message: this.trans.fechaFinalizacionReal,
            disabled: false
          }
        },
        {
          field: 'fechaPlanificadaInicio',
          header: this.trans.fip,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.DATE,
          headerTooltip:{
            message: this.trans.fechaInicioPlanificada,
            disabled: false
          }
        },
        {
          field: 'fechaPlanificadaCierre',
          header: this.trans.fcp,
          dataType: DataColumnType.DATE,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          headerTooltip:{
            message: this.trans.fechaCierrePlanificada,
            disabled: false
          }
        },
        {
          field: 'abrir',
          header: '',
          label: this.trans.abrir,
          icon: 'pi pi-folder-open',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetTramiteActividades) => this.refreshCurrentRoute(data),
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          visible: {
            property: 'fechaRealCierre',
            value: null
          }
        }
      ],
      settings: {
        table: {
          rows: 8
        }
      }
    } as ICustomTable;
  }

  getHistorial() {
    if (!this.tramRegistroId) return;
    this._tas.getTramiteActividades(this.tramRegistroId).subscribe({
      next: (data: IGetTramiteActividades[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  refreshCurrentRoute(data: IGetTramiteActividades): void {
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['/configuracion/actividad', this.tramRegistroId, data.id]);
    });
  }
}
